import * as React from 'react';

import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import ButtonBase from '@mui/material/ButtonBase';

import Bs4MainDispatch from '../../Bs4MainDispatch';
import Bs4I18N from '../../Bs4I18N';

import loginGoogle from '../../Bs4LoginImages/btn_google_signin_light_normal_web.png'
import loginMicrosoft from '../../Bs4LoginImages/ms-symbollockup_signin_light.png'

import Bs4GenericField from './Bs4GenericField';

export default class Bs4ExtLoginField extends Bs4GenericField {
    
  ViewComponentField = (props) => {
    const formField = this;
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR);
    this.refFocus = React.useRef();
    
    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })    
    }, [error]);
    
    const handleLoginGoogle = (event) => {
      Bs4MainDispatch.commandParser('bs4PartnerLogin', { partner: 2, locale: Bs4I18N.getLang()});
    }
  
    const handleLoginMicrosoft = (event) => {
      Bs4MainDispatch.commandParser('bs4PartnerLogin', { partner: 3, locale: Bs4I18N.getLang()});
    }

    return (
      <FormControl 
        id={this.props.inputId}
        ref={this.refFocus}
        fullWidth 
        error={error.error}
        sx={{fontFamily: 'Roboto'}}
      >
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Stack  
          //direction="row" 
          direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row'}}
          justifyContent="center" 
          alignItems="center" 
          sx={{py: 3}}
        >
          <ButtonBase onClick={handleLoginGoogle}><img src={loginGoogle}/></ButtonBase>     
          <Box m={0.5}/>               
          <ButtonBase onClick={handleLoginMicrosoft}><img src={loginMicrosoft}/></ButtonBase>
        </Stack>                      
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }
}